import React from 'react';

import imageClient1 from '../assets/imageClient1.png';
import imageClient2 from '../assets/imageClient2.png';
import imageClient3 from '../assets/imageClient3.jpg';

const Clients = () => {
  const clients = [
    { id: 1, title: 'Gold Containers', image: imageClient1 },
    { id: 2, title: 'WIS Brazil', image: imageClient2 },
    { id: 3, title: 'TKR Inspection', image: imageClient3 },
  ];

  const duplicated = [...clients, ...clients, ...clients];

  return (
    <section className="clients-section">
      <div className="clients-inner">
        <div className="clients-header">
          <p className="section-label">{"Confiança"}</p>
          <h2 className="section-title">Nossos Clientes</h2>
          <p
            className="section-subtitle"
            style={{ margin: '0.75rem auto 0', textAlign: 'center' }}
          >
            {"Empresas que utilizam nossos serviços"}
          </p>
        </div>

        <div className="clients-track-wrapper">
          <div className="clients-track">
            {duplicated.map((client, index) => (
              <div key={`${client.id}-${index}`} className="client-card">
                <img src={client.image} alt={client.title} />
                <h3>{client.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;
